import { axiosInstance } from "../axiosConfig.ts";
import { IGetScheduleResponse } from "./types.ts";

const basePath = "/v1/schedule";

export const scheduleAPI = {
  getSchedule: async (): Promise<IGetScheduleResponse | null> => {
    const response = await axiosInstance.get<IGetScheduleResponse | null>(basePath);
    return response.data;
  },
};
